<app-section sectionTitle="Outputs">
  <!-- MARK: Actions & Filters -->
  <app-subsection subSectionTitle="Actions & Filters">
    <div style="display: flex; flex-direction: column; gap: 16px">
      <div style="display: flex; flex-wrap: wrap; align-items: start">
        <button
          class="form-item-button"
          style="align-self: center; margin: 0px"
          mat-mini-fab
          (click)="craftCalculatorStateService.refreshCraftGroupPrices()"
          [disabled]="this.craftCalculatorStateService.disableButtons() || this.craftCalculatorStateService.craftGroup().inputOutputItemsUniqueNames().length === 0"
          color="primary"
          aria-label="Clear All Button"
          matTooltip="Refresh Prices"
        >
          <mat-icon>refresh</mat-icon>
        </button>
        <button
          class="form-item-button"
          style="align-self: center; margin: 0px 0px 0px 10px"
          mat-mini-fab
          (click)="craftCalculatorStateService.craftGroup().setAllOutputPricesToAodp()"
          color="primary"
          aria-label="Clear All Button"
          matTooltip="Set All Prices to AODP"
        >
          <mat-icon>share</mat-icon>
        </button>
        <div style="display: flex; flex-direction: column; margin: 0px 0px 0px 10px">
          <mat-checkbox style="margin-right: 10px" [(ngModel)]="craftCalculatorStateService.craftGroup().hideUnusedItems">Hide Unused</mat-checkbox>
          <mat-checkbox style="margin-right: 10px" [(ngModel)]="craftCalculatorStateService.craftGroup().onlyMissingPricesItems">Only Missing Prices</mat-checkbox>
        </div>
        <div style="display: flex; flex-direction: column; margin: 0px 0px 0px 10px">
          <mat-checkbox style="margin-right: 10px" [(ngModel)]="craftCalculatorStateService.craftGroup().showCharts">Show Charts</mat-checkbox>
        </div>
      </div>
      <mat-form-field style="width: 98%">
        <mat-label>Text Filter</mat-label>
        <input matInput type="text" [(ngModel)]="searchText" />
        @if (searchText()) {
          <button matSuffix mat-icon-button aria-label="Clear" (click)="searchText.set('')" aria-label="Clear Crafts Search">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    </div>
  </app-subsection>
  <!-- MARK: Table -->
  <app-subsection subSectionTitle="Outputs Table">
    @defer {
      <div class="table mat-elevation-z8">
        <table mat-table [dataSource]="dataSource()" #sort="matSort" matSort matSortStart="desc">
          <!-- Item -->
          <ng-container matColumnDef="item">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">Item</th>
            <td mat-cell *matCellDef="let output">
              <div style="display: flex; align-items: center">
                <div style="display: flex; flex-direction: column; align-items: center; padding-right: 5px; padding-top: 3px">
                  <app-item-image [item]="output.item" [size]="50" [hideTooltip]="true" />
                </div>
                <div style="display: flex; flex-direction: column; align-items: start; text-align: start">
                  <div>
                    {{ output.item.localizedName }}
                  </div>
                  <div>
                    <app-copy-text-button [text]="output.item.localizedName"></app-copy-text-button>
                    <app-check-price-button [itemUniqueName]="output.item.uniqueName"></app-check-price-button>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Amount -->
          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">Amount</th>
            <td mat-cell *matCellDef="let output">
              <div style="display: flex; flex-direction: column; align-items: center; justify-content: center">
                <div>{{ output.totalAmount() | number: '1.2-2' }}</div>
              </div>
            </td>
          </ng-container>

          <!-- Sell Location -->
          <ng-container matColumnDef="location">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">Sell Location</th>
            <td mat-cell *matCellDef="let output">
              <div style="display: flex; align-items: center; justify-content: center">
                <div style="display: flex; flex-direction: row; align-items: center; justify-content: center">
                  <mat-form-field style="width: 240px">
                    <mat-label>Sell Location</mat-label>
                    <mat-select [(ngModel)]="output.sellLocation">
                      @for (location of craftCalculatorStateService.royalMarketLocations; track location.index) {
                        <mat-option [value]="location">{{ location.displayName }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <div style="display: flex; flex-direction: column">
                    <button
                      style="color: var(--accent-color)"
                      [style.opacity]="!output.sellLocation() ? 0.4 : 1"
                      [style.cursor]="!output.sellLocation() ? 'not-allowed' : 'pointer'"
                      mat-icon-button
                      class="mat-icon-button small-icon-button"
                      matTooltip="Propagate Value to All Output Prices"
                      [disabled]="!output.sellLocation()"
                      (click)="this.craftCalculatorStateService.propagateLocation(output.sellLocation()!, 'output')"
                    >
                      <mat-icon>share</mat-icon>
                    </button>
                    <button
                      style="color: var(--accent-color)"
                      [style.opacity]="!output.sellLocation() ? 0.4 : 1"
                      [style.cursor]="!output.sellLocation() ? 'not-allowed' : 'pointer'"
                      mat-icon-button
                      class="mat-icon-button small-icon-button"
                      matTooltip="Propagate Value to Output Prices of Same Category"
                      [disabled]="!output.sellLocation()"
                      (click)="this.craftCalculatorStateService.propagateLocation(output.sellLocation()!, 'output', output.item.groupUniqueName)"
                    >
                      <mat-icon>send</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Sell Price Type -->
          <ng-container matColumnDef="pricetype">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">Sell From</th>
            <td mat-cell *matCellDef="let output">
              <div style="display: flex; align-items: center; justify-content: center">
                <div style="display: flex; flex-direction: row; align-items: center; justify-content: center">
                  <mat-form-field style="width: 240px">
                    <mat-label>Sell Price Type</mat-label>
                    <mat-select [(ngModel)]="output.sellPriceType">
                      @for (type of craftCalculatorStateService.priceTypes; track type.name) {
                        <mat-option [value]="type">{{ type.friendlyName }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  <div style="display: flex; flex-direction: column">
                    <button
                      style="color: var(--accent-color)"
                      [style.opacity]="!output.sellPriceType() ? 0.4 : 1"
                      [style.cursor]="!output.sellPriceType() ? 'not-allowed' : 'pointer'"
                      mat-icon-button
                      class="mat-icon-button small-icon-button"
                      matTooltip="Propagate Value to All Output Prices"
                      [disabled]="!output.sellPriceType()"
                      (click)="this.craftCalculatorStateService.propagatePriceType(output.sellPriceType()!, 'output')"
                    >
                      <mat-icon>share</mat-icon>
                    </button>
                    <button
                      style="color: var(--accent-color)"
                      [style.opacity]="!output.sellPriceType() ? 0.4 : 1"
                      [style.cursor]="!output.sellPriceType() ? 'not-allowed' : 'pointer'"
                      mat-icon-button
                      class="mat-icon-button small-icon-button"
                      matTooltip="Propagate Value to Output Prices of Same Category"
                      [disabled]="!output.sellPriceType()"
                      (click)="this.craftCalculatorStateService.propagatePriceType(output.sellPriceType()!, 'output', output.item.groupUniqueName)"
                    >
                      <mat-icon>send</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- AODP Price -->
          <ng-container matColumnDef="aodpprice">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">AODP Price</th>
            <td mat-cell *matCellDef="let output">
              <div style="display: flex; flex-direction: column; align-items: center; justify-content: center">
                <div style="display: flex; flex-direction: row; align-items: center">
                  <div style="display: flex; flex-direction: column; gap: 6px">
                    <span>{{ output.aodpPrice() ?? 0 | number: '1.2-2' }}</span>
                    @if (output.aodpPriceAge()) {
                      <span>{{ formatHoursAndMinutes(output.aodpPriceAge()) }} old</span>
                    }
                    @if (output.aodpAverage().averageAmount) {
                      <span>{{ output.aodpAverage().averageAmount | smallNumber }} / day</span>
                    }
                  </div>
                  <button style="color: var(--accent-color)" mat-icon-button class="mat-icon-button small-icon-button" matTooltip="Set as Your Sell Price" (click)="output.sellUserPrice.set(output.aodpPrice() ?? 0)">
                    <mat-icon>send</mat-icon>
                  </button>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- User Price -->
          <ng-container matColumnDef="userprice">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">User Price</th>
            <td mat-cell *matCellDef="let output">
              <div style="display: flex; flex-direction: column; align-items: center; justify-content: center">
                <mat-form-field style="max-width: 120px">
                  <mat-label>Your Sell Price</mat-label>
                  <input matInput type="number" step="1" min="0" [(ngModel)]="output.sellUserPrice" />
                </mat-form-field>
              </div>
            </td>
          </ng-container>

          <!-- Chart -->
          <ng-container matColumnDef="chart">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">Chart</th>
            <td mat-cell *matCellDef="let output">
              <div style="display: flex; flex-direction: column; min-width: 180px; align-items: center; justify-content: center">
                <app-spark-line-chart
                  class="width-100"
                  [chosenPrice]="output.sellUserPrice()"
                  [histories]="output.craftGroup.marketHistoriesResponses()"
                  [item]="output.item"
                  [location]="output.sellLocation()"
                  [showButton]="false"
                  [showChart]="true"
                  [hideAmCharts]="true"
                />
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns()"></tr>
          <tr mat-footer-row></tr>
        </table>
      </div>
      <div>
        <mat-paginator #paginator [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons aria-label="Select page of crafts"> </mat-paginator>
      </div>
    } @placeholder {
      <p>Hold tight</p>
    }
  </app-subsection>
</app-section>
